import { actualiteService } from 'core/services';
import { useHistory } from 'react-router';
import React from 'react';
import ActualiteArticleForm from '../Form';
import { ArticleForm, ArticleMode, ArticleModeRouteNames } from 'core/models';

type Props = {
    mode: ArticleMode;
};

const ActualiteArticleCreate: React.FC<Props> = ({ mode }) => {
    const history = useHistory();

    const onSubmit = (actualite: ArticleForm, id?: number) => {
        if (!id) {
            return actualiteService.createArticle(mode, actualite);
        }

        return actualiteService.editArticle(mode, id, actualite).then(() => {
            history.push(`/${ArticleModeRouteNames[mode]}/articles`);
        });
    };

    return <ActualiteArticleForm mode={mode} defaultValues={{ breve: false, deleteThumbnailImage: false }} onCreate={onSubmit}></ActualiteArticleForm>;
};

export default ActualiteArticleCreate;
